import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { Observable, Subscription, filter } from 'rxjs';
import { Calendar } from 'src/app/model/calendar';
import { selectCalendars } from 'src/app/store/calendar/calendar.selector';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionsCalendarDialogComponent } from '../exceptions-calendar-dialog/exceptions-calendar.dialog.component';
import { Site } from 'src/app/model/site';
import * as CalendarActions from 'src/app/store/calendar/calendar.actions'
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
		selector: 'app-calendars-list',
		templateUrl: './calendars-list.component.html',
		providers: [ConfirmationService, DialogService],
		styles: `
			:host ::ng-deep .p-accordion-header-link {
				background-color: #FAFBFF !important;
				border: 1px solid #D5D5D5 !important;
				margin-bottom: 2px;
			}
			:host ::ng-deep .p-accordion-header-link:hover {
				background-color: var(--surface-500) !important;
			}
		`
})
		
export class CalendarsListComponent implements OnInit, OnDestroy {
	// Observables and subscriptions
	calendars$: Observable<Calendar[] | undefined>;
	calendarsSub: Subscription | undefined;

	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;

	calendars: Calendar[];
	currentSite: Site;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1680;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'SCENARIOS'
		}));
		this.subscribeAll();
		this.onResize();
	}

	ngOnDestroy(): void {
		this.calendarsSub?.unsubscribe();
        this.siteSub?.unsubscribe();
	}

	initSelectors(): void{
		// Store selectors
		this.calendars$ = this.store.select(selectCalendars);
        this.site$ = this.store.select(selectCurrentSite);
	}

	subscribeAll(): void {
		this.calendarsSub = this.calendars$?.subscribe(
			(calendars) => {
				this.calendars = calendars;
			}
		);
		this.siteSub = this.site$?.pipe(filter(site => !!site))
			.subscribe(site => {
				this.currentSite = site;
		});
		/* this.calendarAddedSub = this.calendarAdded$?.subscribe(calendarAdded => {
			if (calendarAdded > 0) {
				this.expandedPanel = calendarAdded;
				const s = new Calendar(this.currentSite.Id);
				s.Id = calendarAdded;
				this.addCalendarExclusion(s);
			}
		}); */
	}

	// dialogs
	addCalendarExclusion(): void {
		this.ref = this.dialogService.open(ExceptionsCalendarDialogComponent, {
			header: this.translate.instant('ADD_EXCLUSIONS_CALENDAR'),
			width: '80vw',
			breakpoints: { '1600px' : '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				site: this.currentSite
			},
		});
	}

	editCalendarExclusion(calendar: Calendar): void {
		this.ref = this.dialogService.open(ExceptionsCalendarDialogComponent, {
			header: this.translate.instant('EDIT_EXCLUSIONS_CALENDAR'),
			width: '80vw',
			breakpoints: { '1600px' : '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				calendar: calendar
			},
		});
	}

	deleteCalendarExclusion(calendar: Calendar): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_EXCLUSIONS_CALENDAR'),
			message: this.translate.instant('DELETE_EXCLUSIONS_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(CalendarActions.deleteCalendar({ calendarId: calendar.Id }));
			},
			reject: () => {
			}
		});
	}

	// design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
